import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getUnionAnchorQuitDetail = createAsyncThunk(
  'anchorQuit/getUnionAnchorQuitDetail',
  async (p: {apply_id: string}, store: any) => {
    const resp = await http.post('/live/union/get_secede_union_detail', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
export const updateUnionAnchorQuit = createAsyncThunk(
  'anchorQuit/updateUnionAnchorQuit',
  async (
    p: {
      apply_id?: string
      action: number
      is_check?: boolean
      reason_content: string
      reason_img_urls: string[]
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/union/update_secede_union_detail',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)
interface AnchorQuitState {
  apply_id?: string
  anchor_info?: {mid: number; show_id: string; name: string; avatar: string}
  union_leader_info?: {
    mid: number
    show_id: string
    name: string
    avatar: string
  }
  official_info?: {mid: number; show_id: string; name: string; avatar: string}
  left_dur: number
  status: number
  result: number
  anchor_reason: {content: string; img_urls: string[]}
  leader_reason: {content: string; img_urls: string[]}
  fee_coins: number
  is_leader: boolean
  apply_tm: string // 主播申请时间
  leader_apply_tm: string // 公会长审核时间
  leader_handle_dur: number // 主播X天内不能申请公会
}
const initialState: AnchorQuitState = {
  anchor_info: {} as any,
  union_leader_info: {} as any,
  official_info: {} as any,
  left_dur: 0,
  status: -1,
  result: -1,
  anchor_reason: {content: '', img_urls: []},
  leader_reason: {content: '', img_urls: []},
  fee_coins: 0,
  is_leader: false,
  apply_tm: '',
  leader_apply_tm: '',
  leader_handle_dur: 2,
}
export const anchorQuitSlice = createSlice({
  name: 'AnchorQuit',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUnionAnchorQuitDetail.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(updateUnionAnchorQuit.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
  },
})

export default anchorQuitSlice.reducer
